import React from 'react';
import PropTypes from 'prop-types';

import './modalFooter.scss';


export default function ModalFooter({ children }) {
	return (
		<div className="modal-footer">
			{children}
		</div>
	);
}

ModalFooter.propTypes = {
	children: PropTypes.node
};
